const SHOPIIFY_MAX_RECOMMENDATIONS = 10;
async function getShopifyRecommendations(productId, opts) {
    let url = `${window.Shopify.routes.root}recommendations/products.json?product_id=${[productId]}`;
    if (opts?.limit) {
        url += `&limit=${opts.limit}`;
    }
    if (opts?.intent) {
        url += `&intent=${opts.intent}`;
    }
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`Failed to fetch Shopify recommendations: ${response.statusText}`);
    }
    const json = (await response.json());
    return json.products;
}
/**
 * returns product recommendations from Shopify and sorts products by size and fit availability
 *
 * recommendations are managed via Shopify's Search & Discovery app
 * unfortunately, Shopify doesn't allow us to pass in filters for size and fit, so in-stock is not guaranteed
 *
 * @param productId
 * @param size
 * @param fit
 * @returns
 */
export async function getShopifyInStockRecommendations(productId, size, fit) {
    const recs = await getShopifyRecommendations(productId, { limit: SHOPIIFY_MAX_RECOMMENDATIONS });
    const matchChecks = [];
    if (size) {
        matchChecks.push({
            field: 'size',
            value: size.toLowerCase(),
        });
    }
    if (fit) {
        matchChecks.push({
            field: 'fit',
            value: fit.toLowerCase(),
        });
    }
    return recs.map((rec) => {
        const matchFieldPositions = matchChecks.reduce((acc, check) => {
            return { ...acc, [check.field]: rec.options.find((o) => o.name.toLowerCase() === check.field)?.position || 0 };
        }, {});
        const hasAtLeastOneMatchField = matchChecks.some((check) => matchFieldPositions[check.field] > 0);
        if (!hasAtLeastOneMatchField)
            return rec;
        const matchingVariant = rec.variants.find((v) => {
            return v.available && matchChecks.every((check) => {
                const position = matchFieldPositions[check.field];
                if (position === 0)
                    return true; // product doesn't have this option, so the check is not applicable
                return v.options[position - 1]?.toLowerCase() === check.value;
            });
        });
        return matchingVariant ? { ...rec, matched_variant_sku: matchingVariant.sku } : rec;
    }).sort((a, b) => (a.matched_variant_sku ? -1 : 1) - (b.matched_variant_sku ? -1 : 1)); // sort by in-stock availability
}
